export default "__VITE_ASSET__BulOxNfG__"